import styled from 'styled-components';

export const DataCaptureWrapper = styled.div`
  margin-bottom: 75px;
`;
